import lazySizes from 'lazysizes';

lazySizes.init();

// Barba JS config
import './barba.js';

// additional modules
import './menu.js';
import './side-anchors.js';

// scroll to top
const footerTopLink = document.querySelector('.footer-top__link');

const scrollToTop = e => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

footerTopLink.addEventListener('click', scrollToTop);

// scroll to finishes
const scrollToFinishes = e => {
    e.preventDefault();
    const finishes = document.querySelector('.acrylic');
	finishes.scrollIntoView({behavior: "smooth", alignToTop: true});
}

export const addFinishesListeners = () => {
    const finishesLink = document.querySelector('#customs-partitions-hero .partitions-hero__copy--button');
    if (finishesLink) {
        finishesLink.addEventListener('click', scrollToFinishes);
    }
}

export const removeFinishesListeners = () => {
    const finishesLink = document.querySelector('.partitions-hero__copy--button');
    if (finishesLink) {
        finishesLink.removeEventListener('click', scrollToFinishes);
    }
}

addFinishesListeners();

// use lottie js for hero-video & fabrication sections (cdn at footer)
import './hero-animation.js';
import './fabrication-animations.js';

// Glide JS config
import './render-carousels.js';

// Swiper JS config
import './swiper-carousel.js';
